import React from 'react';
import { portfolioData } from '../../data/portfolioData';
import './Skills.css';

const Skills = () => {
  const { skills } = portfolioData;

  const SkillCategory = ({ title, skillList }) => (
    <div className="skill-category">
      <h3>{title}</h3>
      <div className="skills-list">
        {skillList.map((skill, index) => (
          <span key={index} className="skill-tag">{skill}</span>
        ))}
      </div>
    </div>
  );

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2>Technical Skills</h2>
        <div className="skills-grid">
          <SkillCategory title="Programming Languages" skillList={skills.languages} />
          <SkillCategory title="Frameworks & Libraries" skillList={skills.frameworks} />
          <SkillCategory title="Databases" skillList={skills.databases} />
          <SkillCategory title="Cloud & DevOps" skillList={skills.cloudDevops} />
          <SkillCategory title="IDEs & Tools" skillList={skills.ides} />
          <SkillCategory title="Operating Systems" skillList={skills.operatingSystems} />
          <SkillCategory title="Methodologies" skillList={skills.methodologies} />
          <SkillCategory title="Networking" skillList={skills.networking} />
        </div>
      </div>
    </section>
  );
};

export default Skills;